import { render, staticRenderFns } from "./TranslationInput.vue?vue&type=template&id=03730f49"
import script from "./TranslationInput.vue?vue&type=script&lang=ts"
export * from "./TranslationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03730f49')) {
      api.createRecord('03730f49', component.options)
    } else {
      api.reload('03730f49', component.options)
    }
    module.hot.accept("./TranslationInput.vue?vue&type=template&id=03730f49", function () {
      api.rerender('03730f49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TranslationInput.vue"
export default component.exports